
define('text!templates/appMain/privilegedMain/qm/policies/editors/wrapUpCodeSelectorNameList.html',[],function () { return '<!-- ko foreach: wrapUpCodes -->\n    <div class="wrap-up-code-name" data-bind="text: name"></div>\n<!-- /ko -->';});

